import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

const useStoreUpdateApi = ({ service, form, messageApi, queryKey, route }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleError = (error) => {
    const data = error?.response?.data;

    if (
      data?.errors &&
      !Array.isArray(data.errors) &&
      typeof data.errors === "object"
    ) {
      const fieldErrors = Object.keys(data.errors).map((key) => ({
        name: key,
        errors: Array.isArray(data.errors[key])
          ? data.errors[key]
          : [data.errors[key]],
      }));

      form.setFields(fieldErrors);
    }

    if (Array.isArray(data?.errors) && typeof data.errors[0] === "object") {
      const combined = data.errors
        .map((err) => {
          if (err.message) return err.message;

          const field = Object.keys(err)[0];
          return err[field];
        })
        .join(", ");

      messageApi.error(combined);
      return;
    }

    if (Array.isArray(data?.errors) && typeof data.errors[0] === "string") {
      messageApi.error(data.errors.join(", "));
      return;
    }

    if (data?.message) {
      messageApi.error(data.message);
      return;
    }

    messageApi.error("Terjadi kesalahan, silakan coba lagi.");
  };

  const storeMutation = useMutation({
    mutationFn: (data) => service.store(data),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
      messageApi.success("Data berhasil disimpan");
      form.resetFields();
      navigate(route);
    },
    onError: handleError,
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => service.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKey);
      messageApi.success("Data berhasil diperbarui");
      form.resetFields();
      navigate(route);
    },
    onError: handleError,
  });

  return { storeMutation, updateMutation };
};

const useGetDetailApi = ({ serviceFn, id, status, queryKey }) => {
  const query = useQuery({
    queryKey: [...queryKey, id, status],
    queryFn: () => {
      if (status !== undefined) {
        return serviceFn(id, status);
      }
      return serviceFn(id);
    },
    enabled: !!id,
    select: (data) => data.data,
  });

  return query;
};

export { useStoreUpdateApi, useGetDetailApi };
